<template>
  <div class="left">
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width="86" height="87" viewBox="0 0 86 87" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M58.1051 18.0219C60.2724 14.7322 64.6708 13.8435 67.9289 16.0366C70.9887 18.1007 71.952 22.1643 70.245 25.3823L69.8909 25.9772L41.5596 68.9787C39.2081 72.5407 34.3635 73.2 31.1762 70.5411L30.6592 70.0681L16.4935 55.7342C13.7242 52.9391 13.7242 48.3953 16.4935 45.6002C19.0858 42.9771 23.1868 42.8123 25.9703 45.1057L26.5086 45.6002L34.5618 53.749L58.1051 18.0219Z"
          fill="#21CD21" />
      </svg>
    </div>
    <div class="success text-title">
      {{ $vt('Your order has been successfully processed') }}
    </div>
    <div>
      <f-button type="tertiary" blank :href="component.invoice_pdf">{{ $vt('Download invoice') }} <f-icon
          icon="fa6-circle-down"></f-icon></f-button>
    </div>
  </div>
</template>
<script>
export default {
  translate25Context: 'stripe',
  props: ["component", "handler"],
}
</script>